import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { DBSecondaryIndustry } from '../../models/stack9/SecondaryIndustry';
import { SecondaryIndustryDrawer } from '../SecondaryIndustryDrawer/SecondaryIndustryDrawer';

const S9Button = ui.S9Button.default;
const { useRefreshList } = ui;

export const config: S9ComponentConfig = {
  name: 'SecondaryIndustryDrawerAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type SecondaryIndustryDrawerActionProps = {
  row: Partial<DBSecondaryIndustry>;
};

const SecondaryIndustryDrawerAction = ({
  row,
}: SecondaryIndustryDrawerActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();

  return (
    <>
      <S9Button
        type="link"
        style={{ width: '100%', textAlign: 'left' }}
        onClick={() => setIsOpen(true)}
        label={`${row.code}`}
      />
      <SecondaryIndustryDrawer
        initialValues={row}
        id={row?.id}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
      />
    </>
  );
};

export default SecondaryIndustryDrawerAction;
